import { CollectionOrigin } from "../collection";
import { z } from "zod";
export const CollectionImportModelInput = z.object({
    id: z.string(),
    name: z.string(),
    parentId: z.string().optional(),
    collectionKeyMigrated: z.boolean(),
});
export const CollectionImportModel = z.object({
    id: z.string(),
    parentId: z.string().optional(),
    name: z.string(),
    origin: CollectionOrigin,
});
